const map = {
	"./broadcast-active.png": "./src/assets/img/emulation/broadcast-active.png",
	"./broadcast.png": "./src/assets/img/emulation/broadcast.png",
	"./ethernet-active.png": "./src/assets/img/emulation/ethernet-active.png",
	"./ethernet-add-active.png": "./src/assets/img/emulation/ethernet-add-active.png",
	"./ethernet-add.png": "./src/assets/img/emulation/ethernet-add.png",
	"./ethernet.png": "./src/assets/img/emulation/ethernet.png",
	"./satellite-active.png": "./src/assets/img/emulation/satellite-active.png",
	"./satellite.png": "./src/assets/img/emulation/satellite.png",
	"./wifi-active.png": "./src/assets/img/emulation/wifi-active.png",
	"./wifi.png": "./src/assets/img/emulation/wifi.png"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/emulation sync recursive ^\\.\\/.*$";